import * as angular from "angular";
import {IController, IWindowService} from "angular";
import * as _ from "lodash";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {PreferencesDialogService} from "../../services/preferences-dialogs-service.service";
import {CommonsAlertsService} from "../../../commons/services/commons-alerts.service";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {BringozToastService} from "../../../commons/services/bringoz-toast.service";
import {SplitService} from "../../../commons/services/split-service.service";
import {ConfigurationCommons} from "../../../commons/services/configuration-commons.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {EnvironmentType} from "../../../commons/types/environment.type";

export class preferencesTabCtrl implements IController {

  preferences: any;
  parentGroup: string;
  colorThemesList: string[];

  public environment: EnvironmentType;

  /* @ngInject */
  constructor(private preferencesDialogService: PreferencesDialogService, private moment, private $window: IWindowService, private apiConfig,
              private commonsAlertsService: CommonsAlertsService, private commonsDialogService: CommonsDialogService, private confirmDialogService: ConfirmDialogService,
              private bringozToastService: BringozToastService, private splitService: SplitService, private configurationCommons: ConfigurationCommons,
              private $preferences, private $log, private bringozLoaderService: BringozLoaderService, private commonsConstants) {
  }

  $onInit() {
    this.environment = this.apiConfig.env;
    this.colorThemesList = this.commonsConstants.colorPalletWebTracker;
  }

  // Pop-up sent to element-pop-up directive, once returned updating $preferences in server.
  onEdit(event, property, index) {
    this.preferencesDialogService.editPreferencesProperty(event, property)
      .then((updated) => {
        const updatedValue = updated[0];
        const group = _.camelCase(updatedValue.group);

        this.preferences[group].list[index] = updatedValue;

        this.commonsAlertsService.preferencesByNameSuccess('preferences.' + property.key + '.name');
      })
      .catch((error) => {
        if (error) {
          this.commonsAlertsService.preferencesError();
        }
      })
  }

  onUploadJSON(event) {
    this.commonsDialogService.uploadJSON(event)
      .then((validProperties) => {

        const parentGroup = _.get(validProperties, '[0].parentGroup');
        if (_.camelCase(parentGroup) === _.camelCase(this.parentGroup)) {

          this.confirmDialogService.confirm('Update Settings', 'Are you sure you want to update?', event)
            .then(() => {
              validProperties.forEach((p) => {
                p.siteId = this.splitService.getSiteId();
              })

              this._updateAllPreferences(validProperties);
            })
        } else {
          this.commonsAlertsService.updateJsonMismatchError();
        }
      })
  }

  onCopyJSON() {
    let allProperties = [];

    _.forOwn(this.preferences, (card: any, keyName: string) => {
      allProperties = allProperties.concat(card.list);
    })

    const text = JSON.stringify(allProperties);
    this.$window.navigator.clipboard.writeText(text).then((succ) => {
      const message = {
        body: 'TEXT_COPIED_TO_CLIPBOARD'
      };
      this.bringozToastService.success(message);
    });
  }


  onWebTrackerColorPicked(event, property, index, clickedColor) {
    if (property.value === clickedColor) {
      return;
    }

    let propertValue = angular.copy(property);
    propertValue.value = clickedColor;

    this.bringozLoaderService.on();
    this.$preferences().$post([propertValue])
      .then((updated) => {
        const updatedValue = updated[0];
        const group = _.camelCase(updatedValue.group);

        this.preferences[group].list[index] = updatedValue;
        this.commonsAlertsService.preferencesByNameSuccess('preferences.' + property.key + '.name');
      })
      .catch((error) => {
        if (error) {
          this.$log.error('Error while updating preferences value, preferencesDialogService@editPreferencesProperty: \n' + error);
          this.commonsAlertsService.preferencesError();
        }
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

  }

  private _updateAllPreferences(properties: any[]) {
    const propertiesToSend = [];
    properties.forEach((p) => {
      const property = angular.copy(p);

      if (property && _.isEqual(property.valueType, 'Date')) {
        property.value = JSON.stringify(this.moment(property.value).valueOf());
      }
      propertiesToSend.push(property);
    })

    this.bringozLoaderService.on();

    this.$preferences().$post(propertiesToSend)
      .then((updatedPreferences) => {
        this.preferences = this.configurationCommons.getPreferencesByGroup(updatedPreferences)[_.camelCase(this.parentGroup)];

        this.commonsAlertsService.preferencesUpdateSuccess();
      })
      .catch((error) => {
          this.commonsAlertsService.preferencesError();
          this.$log.error('Error while updating preferences, @_updateAllPreferences: \n' + error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

}

angular
  .module('bringoz.admin.site-preferences')
  .component('preferencesTab', {
    bindings: {
      preferences: '<',
      parentGroup: '<'
    },
    template: require('./preferences-tab.html').default,
    controller: preferencesTabCtrl
  });
